import { indexWrapCss } from "../../Main/css/Main.style";
import Header from "../header/Header";
import React, { useState } from "react";
import Footer from "../footer/Footer";
import { useNavigate } from "react-router-dom";
import usePageTitle from "../../../hooks/usePageTitle";

const Terms = () => {
    usePageTitle("이용약관");


    const [search, setSearch] = useState<any>([]);
    const onSearchHandler = (e: any) => {
        setSearch(e.target.value);
    };
    const navigate = useNavigate();

    return (
        <>
            <div css={indexWrapCss}>
                <Header
                    onChange={onSearchHandler}
                    searchValue={search}
                    name="search"
                    activeFlag=""
                />

                <div
                    className="max-w-[1200px] w-full min-w-0 mx-auto flex flex-col gap-20 py-[120px] px-6 text-black">
                    <span className={"text-2xl font-bold"}>이용약관</span>


                    <div className={"text-base"}>

                        <p>
                            본 약관은 북밋(이하 "회사")이 제공하는 웹사이트 및 관련 서비스(이하 "서비스")의 이용과 관련하여 회원과 회사 간의 권리, 의무 및 책임사항을 규정함을
                            목적으로
                            합니다.
                        </p>

                        <hr className="w-full border-t border-black my-4 " />


                        <p>제1조 (목적)</p>
                        <span>본 약관은 회사가 제공하는 서비스의 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정합니다.</span>

                        <hr className="w-full border-t border-black my-4 " />

                        <p>제2조 (정의)</p>
                        <p>1. "회원"이란 회사의 서비스에 접속하여 본 약관에 동의하고, 회원가입을 통해 회사와 이용계약을 체결한 자를 말합니다.</p>
                        <p>2. "콘텐츠"란 웹사이트에 게시되거나 제공되는 문자, 이미지, IP 기반 창작물(예: 작가의 엽서), 기능 등을 의미합니다.</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p>제3조 (약관의 효력 및 변경)</p>
                        <p>1. 본 약관은 서비스 화면에 게시하거나 기타 방법으로 회원에게 공지함으로써 효력을 발생합니다.</p>
                        <p>2. 회사는 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있으며, 개정된 약관은 적용일 전 7일 이상 사전 공지합니다.</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p>제4조 (회원가입)</p>
                        <p> 1. 회원가입은 이용자가 본 약관에 동의하고, 회사가 정한 절차에 따라 회원가입을 완료함으로써 성립합니다.</p>
                        <p>2. 회사는 다음 각 호에 해당하는 경우 회원가입 신청을 거부하거나 취소할 수 있습니다:</p>
                        <p className={"pl-4"}> o 타인의 명의 또는 정보를 도용한 경우</p>
                        <p className={"pl-4"}> o 허위 정보를 입력한 경우</p>
                        <p className={"pl-4"}> o 기타 회사의 운영에 지장을 초래하는 경우</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p>제5조 (회원 정보의 관리)</p>
                        <p> 회원은 자신의 계정 정보를 성실히 관리할 책임이 있으며, 이를 타인에게 제공하거나 도용당하지 않도록 주의해야 합니다.</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p>제6조 (서비스의 제공 및 변경)</p>
                        <p> 1. 회사는 회원에게 다음과 같은 서비스를 제공합니다:</p>
                        <p className={"pl-4"}>o 작가 콘텐츠 열람</p>
                        <p className={"pl-4"}>o 작가 팔로우 및 콘텐츠 좋아요 기능</p>
                        <p className={"pl-4"}>o 기타 회사가 정하는 기능</p>
                        <p> 2. 회사는 서비스 운영상 필요한 경우 콘텐츠 및 서비스를 변경할 수 있으며, 사전에 이를 공지합니다.</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제7조 (서비스 이용의 제한)</p>
                        <p> 회사는 다음 각 호에 해당하는 경우 사전 통지 없이 회원의 서비스 이용을 제한할 수 있습니다:</p>
                        <p className={"pl-4"}>• 법령 또는 약관을 위반한 경우</p>
                        <p className={"pl-4"}> • 타인의 권리를 침해하거나 명예를 훼손한 경우</p>
                        <p className={"pl-4"}> • 시스템 장애 또는 비정상적 사용이 발생한 경우</p>
                        <p className={"pl-4"}> • 선정적인 사진 또는 업로드에 적합하지 않은 기타 사유가 확인된 경우, 해당 계정의 비활성화 또는 이용 제한
                            조치를 할 수
                            있습니다</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제8조 (지식재산권)</p>
                        <p> 1. 서비스에 포함된 모든 콘텐츠의 저작권은 회사 또는 콘텐츠 제공자에게 있습니다.</p>
                        <p> 2. 회원은 회사의 동의 없이 콘텐츠를 복제, 배포, 전송, 전시하거나 2차적 저작물을 작성할 수 없습니다.</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제9조 (회원 탈퇴)</p>
                        <p> 회사는 회원 탈퇴 기능을 제공하지 않으며, 회원이 개인정보 삭제를 요청할 경우 이를 지체 없이 처리합니다.</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제10조 (면책조항)</p>
                        <p> 1. 회사는 천재지변, 기술적 장애 등 불가항력적인 사유로 서비스를 제공할 수 없는 경우 책임을 지지 않습니다.</p>
                        <p> 2. 회사는 회원 간 또는 회원과 제3자 간에 발생한 분쟁에 개입하지 않으며, 이로 인한 손해에 대해서도 책임을
                            지지 않습니다.</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제11조 (준거법 및 관할)</p>
                        <p> 본 약관은 대한민국 법률에 따라 해석되며, 서비스 이용과 관련한 분쟁은 서울중앙지방법원을 1심 관할 법원으로
                            합니다.</p>

                        <p> 시행일자: 2025년 5월 14일</p>
                    </div>


                    <div className="flex w-full justify-center">
                        <button
                            onClick={() => navigate("/")}
                            className="border-2 border-main bg-white px-8 md:px-[100px] py-[14px] rounded-full font-namsan text-lg text-main font-bold max-w-full"
                        >
                            홈으로 돌아가기
                        </button>
                    </div>


                </div>

            </div>


            <Footer />

        </>
    )

}

export default Terms;
